import { Panel } from "capitalrx-components-2.0/lib/general";
import { Shelf, useResponsive } from "capitalrx-components-2.0/lib/layout";
import "./PrintableWrapper.scss";
import { CSSProperties, PropsWithChildren, forwardRef } from "react";

export const PrintableWrapper = forwardRef<HTMLDivElement, PropsWithChildren<{innerPadding?: CSSProperties["padding"]}>>(function PrintableWrapper(props, ref) {
  const { children, innerPadding } = props;
  const { width, minHeight, padding, shelfStyle } = useResponsive({
    width: {
      mobile: "816px",
      desktop: "816px",
      tablet: "816px",
    },
    minHeight: {
      mobile: "",
      desktop: "881px",
    },
    padding: {
      mobile: 0,
      desktop: 48,
    },
    shelfStyle: {
      desktop: {
        width: "816px",
        minWidth: "816px",
        margin: "auto",
      },
      mobile: {
        width: "816px",
        minWidth: "816px",
      },
      tablet: {
        width: "816px",
        minWidth: "816px",
        margin: "auto",
      },
    },
  });

  return (
    <div style={{ padding }}>
      <Shelf alignment="center" style={shelfStyle}>
        <Panel style={{ minWidth: width, width: width, minHeight, padding: 0 }}>
          <div className="printable-container" ref={ref} style={{ padding: innerPadding ? innerPadding : "2rem" }}>
            {children}
          </div>
        </Panel>
      </Shelf>
    </div>
  );
});
